<template>
  <ul class="my-0 list-unstyled">
    <matches v-if="!isEmpty(matches)"
      :matches="matches"
      view="popover"
    />

    <li v-if="abstract" class="row-content row-content_text">
      <span
        class="row-content--main"
        v-html="abstract"
        v-line-clamp="4"
      />
    </li>

    <partial-research-groups v-if="!isEmpty(researchGroups)"
      :researchGroups="researchGroups"
      :highlights="highlights"
      :renderWithLinkTo="false"
      :truncate="-1"
      :isText="true"
      :containerClass="`mt-2 row-content_text`"
      :lineClamp="3">
    </partial-research-groups>

    <partial-owners v-if="!isEmpty(authors)"
      :owners="authors"
      :maxItems="maxAuthors"
      :isSlicedInMiddle="data.top_authors.length > maxAuthors ? true : false"
      :renderWithLinkTo="false"
      :isText="true"
      :text="'Authors: '"
      :containerClass="`mt-2 row-content_text`"
      :lineClamp="3">
    </partial-owners>

    <li v-if="data.publication_date" class="mt-2 row-content row-content_text">
      <span class="row-content--main">
        <span class="t-500">Publication Date:</span>
        {{ this.data.publication_date | formatDate('YYYY') }}
      </span>
    </li>
    <template v-if="journal">
      <li class="row-content row-content_text">
        <span class="row-content--main">
          <span class="t-500">Journal Title:</span>
          <span v-html="journal.name"></span>
        </span>
      </li>
      <li v-if="journal.ranking_h_index" class="row-content row-content_text">
        <span class="row-content--main">
          <span class="t-500"><i>h</i>-index:</span>
          <span v-html="journal.ranking_h_index"></span>
        </span>
      </li>
    </template>
  </ul>
</template>

<script>
import processing from '@/mixins/search/results/publication'

import PartialOwners from '@/components/search/results/partials/Owners'
import PartialResearchGroups from '@/components/search/results/partials/ResearchGroups'
import Matches from '@/components/search/results/partials/Matches'

export default {
  name: 'publicationResultPopover',
  mixins: [processing],
  components: {
    PartialOwners,
    PartialResearchGroups,
    Matches
  },
  data () {
    return {
      maxAuthors: 10
    }
  },
  mounted () {
    if (
      !this.isEmpty(this.matches) ||
      this.abstract ||
      !this.isEmpty(this.researchGroups) || !this.isEmpty(this.authors) ||
      this.data.publication_date ||
      this.journal
    ) {
      this.$emit('setIsEmptyPopover', false)
    } else {
      this.$emit('setIsEmptyPopover', true)
    }
  }
}
</script>
